import * as Actions from '../actions';

const initialState = {
    table_sort: {},
    table_filter: {},
    table_page_size: {},
    is_loaded: false,
}

const tableSortReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_TABLE_PREFENCES):
            {
                const { table_sort, table_filter, table_page_size } = action.payload;

                return {
                    ...state,
                    table_sort: table_sort,
                    table_filter: table_filter,
                    table_page_size: table_page_size,
                    is_loaded: true,
                }
            }

        case (Actions.SET_TABLE_SORT):
            {
                const { table_name, sort_list } = action.payload;

                return {
                    ...state,
                    table_sort: {
                        ...state.table_sort,
                        [table_name]: sort_list,
                    }
                }
            }

        case (Actions.GET_ALL_TABLE_FILTERING):
            {
                return {
                    ...state,
                    table_filter: action.payload
                }
            }

        case (Actions.SET_TABLE_FILTER):
            {
                const { table_name, filter_list } = action.payload;

                return {
                    ...state,
                    table_filter: {
                        ...state.table_filter,
                        [table_name]: filter_list,
                    }
                }
            }

        case (Actions.RESET_TABLE_FILTER):
            {
                const { table_name } = action.payload;

                return {
                    ...state,
                    table_filter: {
                        ...state.table_filter,
                        [table_name]: [],
                    }
                }
            }

        case (Actions.SET_TABLE_PAGE_SIZE):
            {
                const { table_name, page_size } = action.payload;

                // let new_table_page_size = state.table_page_size;
                // new_table_page_size[table_name] = page_size;

                return {
                    ...state,
                    table_page_size: {
                        ...state.table_page_size,
                        [table_name]: page_size,
                    }
                }
            }

        case (Actions.CONVERT_SIDE_PANEL_FILTER_TO_PROPS):
            // This take the format of the side table filters and converts it to the original format so the props can be updated
            {
                const { table_name, filter_list } = action.payload;

                const formatted = filter_list.filter(c => c.active).map(col => {
                    return {
                        id: col.column_id,
                        value: {
                            filterMenuEl: null,
                            filterType: col.filterType,
                            filterValue: col.value
                        }
                    }
                })

                return {
                    ...state,
                    table_filter: {
                        ...state.table_filter,
                        [table_name]: formatted,
                    }
                }
            }

        default:
            {
                return state;
            }

    }
}

export default tableSortReducer;


// WEBPACK FOOTER //
// src/main/components/tableSort/store/reducers/table_sort.reducer.js